/**
 * Footer
 */
import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

// intl messages
import IntlMessages from 'Util/IntlMessages';

// app config
import AppConfig from 'Constants/AppConfig';

const Footer = () => (
	<div className="rct-footer d-flex justify-content-between align-items-center">
		<ul className="list-inline footer-menus mb-0">
			<li className="list-inline-item">
				<Button onClick={(e) => {
							e.preventDefault();
							window.location.href='http://google.com';
							}}>Developed By Novus Solutions</Button>
			</li>
			
		</ul>
		<h5 className="mb-0">{AppConfig.copyRightText}</h5>
	</div>
);

export default Footer;
